export const NIVA_BASE_URL = "https://getniva.ai";
export const NIVA_NAV_URL = `${NIVA_BASE_URL}?utm_source=nivalabs&utm_medium=header&utm_campaign=niva_cta`;
export const NIVA_LIVE_DEMO = `${NIVA_BASE_URL}/niva-main-site/`;
export { CALENDLY_URL as NIVA_BOOK_DEMO } from "./site.config";
export { CALENDLY_URL } from "./site.config";
